import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const Cta = () => {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("home");
      setHome(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!home) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div className="cta">
      {" "}
      <div
        id="rs-slider1"
        class="rs-slider-banner images-overlay rs-slider-banner5"
      >
        <div id="home-banner">
          <div class="item active">
            <img
              src="https://static.vecteezy.com/system/resources/previews/008/680/961/non_2x/abstract-technology-background-free-vector.jpg"
              alt=""
            />
            <div class="slide-content">
              <div class="banner-content text-center">
                <h2
                  class="slider-title"
                  data-animation-in="fadeInLeft"
                  data-animation-out="animate-out"
                >
                  {home.acroynm[0].text}
                </h2>

                {/* <div
                  data-animation-in="fadeInUp"
                  data-animation-out="animate-out"
                  class="slider-desc px-5"
                >
                  <h2 className="text-white">
                    2nd International Conference on Technological Innovations
                    and Advance Computing
                    <br />
                  </h2>
                </div> */}
                {/* <h5 className="text-white">at</h5> */}
                <div
                  data-animation-in="fadeInUp"
                  data-animation-out="animate-out"
                  class="slider-desc"
                >
                  <h4 className="text-white">
                    {home.oragnized[0].text}
                  </h4>
                </div>
                <div class="date-meta">
                  <span>
                    <i class="fa fa-calendar" aria-hidden="true"></i>{" "}
                    {home.conference_date[0].text}
                  </span>
                  {/* <div className="cflex">
                    <p class="su-btn">
                      <a href="https://cmt3.research.microsoft.com/ICITEICS2024">
                        Submit Paper
                      </a>
                    </p>
                    <p class="su-btn">
                      <a href="https://cmt3.research.microsoft.com/ICITEICS2024">
                        Registration
                      </a>
                    </p>
                  </div> */}
                </div>
              </div>
              {/* <div class="slider-shape2"></div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cta;
